/* global OfficeRuntime console */

interface AuthHeader {
  [Authorization: string]: string;
}

let firstSignin = true;

export async function authHeader(): Promise<AuthHeader> {
  const userTokenEncoded = await OfficeRuntime.auth.getAccessToken({
    // Allow these prompts only the first time to avoid Office API throttling.
    allowConsentPrompt: firstSignin,
    allowSignInPrompt: firstSignin,
  });
  if (userTokenEncoded) {
    firstSignin = false;
    console.log(`Using access token from Office. Token length = ${userTokenEncoded.length}`);
  } else {
    console.error("No access token received from Office");
  }
  return {
    Authorization: `Bearer ${userTokenEncoded}`,
  };
}
